import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Box from '@mui/material/Box';

function MultiFormErrorDialog({ feesError, docsError, onClose }) {
  return (
    <Dialog open={!!feesError || !!docsError} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ErrorOutlineIcon color="error" fontSize="large" />
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: 'error.main' }}>
          Error
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ mt: 1 }}>
          <Typography variant="body1" color="text.primary">
            { feesError &&
              <div> Fees Error: {feesError}</div>
            }
            { docsError &&
              <div> Docs Error: {docsError}</div>
            }
          </Typography>

        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="error" variant="contained" sx={{ px: 3 }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MultiFormErrorDialog;
